import { useState } from "react";
import { StickyNote } from "lucide-react";
import api, { apiError } from "../lib/api";
import { useFlash } from "../lib/flash";

export default function NoteEditor({ cid, note, onSaved }) {
  const flash = useFlash();
  const [v, setV] = useState(note || "");
  const [busy, setBusy] = useState(false);
  const dirty = v.trim() !== (note || "");
  const save = async () => {
    setBusy(true);
    try {
      const r = await api.put(`/customers/${cid}/note`, { note: v });
      flash(r.data.flash || "Gemt");
      onSaved?.(r.data.note);
    } catch (err) {
      flash(apiError(err.response?.data?.detail) || err.message, "error");
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="cp-note" data-testid="cp-note">
      <label htmlFor={`note-${cid}`} className="cp-sub"><StickyNote size={15} /> Note</label>
      <textarea id={`note-${cid}`} rows={3} maxLength={500} value={v} placeholder="Fx ringer altid i forvejen"
        onChange={(e) => setV(e.target.value)} data-testid="cp-note-input" />
      <div className="cp-note-foot">
        <small className="muted">{v.length}/500</small>
        <button className="btn small primary" disabled={!dirty || busy} onClick={save} data-testid="cp-note-save">
          {busy ? "Gemmer…" : "Gem note"}
        </button>
      </div>
    </div>
  );
}
